// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UpgradeWith_wrapper__U_PVT","title":"UpgradeWith_title__PAEvO"};